import { apiClient } from './axios';

import type {
  BookingQuery,
  BookingWithRelations,
  CreateBookingDto,
  PaginatedResponse,
  UpdateBookingDto,
} from '@repo/shared-types';

export const bookingsApi = {
  getAll: async (query: Partial<BookingQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<BookingWithRelations>>('/bookings', {
      params: query,
    });
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<BookingWithRelations>(`/bookings/${id}`);
    return response.data;
  },

  create: async (data: CreateBookingDto) => {
    const response = await apiClient.post<BookingWithRelations>('/bookings', data);
    return response.data;
  },

  update: async (id: string, data: UpdateBookingDto) => {
    const response = await apiClient.patch<BookingWithRelations>(`/bookings/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/bookings/${id}`);
  },

  setAttendance: async (id: string, attendance: 'attended' | 'not_attended' | null) => {
    const response = await apiClient.patch<BookingWithRelations>(`/bookings/${id}/attendance`, {
      attendance,
    });
    return response.data;
  },

  cancelByPhone: async (phone: string) => {
    const response = await apiClient.patch<{ cancelled: number }>(
      `/bookings/cancel-by-phone/${encodeURIComponent(phone)}`,
    );
    return response.data;
  },

  exportExcel: async (query: Partial<BookingQuery> = {}, filename = 'bookings.xlsx') => {
    const response = await apiClient.get('/bookings/export', {
      params: query,
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
